module.exports = __webpack_public_path__ + "static/media/Dey.7bcb06c6.svg";